import CstCClassTribService from "@/services/CstCClassTribService";

export const cstCClassTrib = {
  namespaced: true,
  state: {
    cstCClassTrib: {},
  },
  actions: {
    getCstCClassTrib({ commit }, payload) {
      return CstCClassTribService.GetCstCClassTrib(payload).then(
        (cstCClassTrib) => {
          return Promise.resolve(cstCClassTrib);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCstCClassTrib({ commit }, payload) {
      return CstCClassTribService.PostCstCClassTrib(payload).then(
        (cstCClassTrib) => {
          return Promise.resolve(cstCClassTrib);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCstCClassTrib({ commit }, payload) {
      return CstCClassTribService.PutCstCClassTrib(payload).then(
        (cstCClassTrib) => {
          return Promise.resolve(cstCClassTrib);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCstCClassTrib({ commit }, payload) {
      return CstCClassTribService.DeleteCstCClassTrib(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCstCClassTribOData({ commit }, payload) {
      return CstCClassTribService.GetCstCClassTribOData(payload).then(
        (cstCClassTrib) => {
          return Promise.resolve(cstCClassTrib);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    atualizarTabelaCstCClassTrib({ commit }, payload) {
      return CstCClassTribService.AtualizarTabelaCstCClassTrib(payload).then(
        (cstCClassTrib) => {
          return Promise.resolve(cstCClassTrib);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default cstCClassTrib;
